import { Typography } from '@mui/material'
import React from 'react'

function DataNotFound() {
    return (
        <Typography variant='body1' color={'error.main'} textAlign={'center'}>Data Not Found</Typography>
    )
}

export default DataNotFound
